// src/pages/Sample.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { generatePDF } from '../utils/pdfGenerator';

const sampleData = {
  certId: 'COA-2026-0001',
  product: {
    chemName: 'Acetylsalicylic Acid',
    casNumber: '50-78-2',
    formula: 'C₉H₈O₄',
    weight: '180.16 g/mol',
    batch: 'BTH-2026-001',
    mfgDate: '2026-06-01',
    expDate: '2028-06-01',
    appearance: 'White crystalline powder',
    storage: 'Store in a cool, dry place',
    country: 'United States',
  },
  specs: [
    { parameter: 'Appearance',       specification: 'White crystalline powder', result: 'White crystalline powder', unit: '',   method: 'Visual' },
    { parameter: 'Assay (HPLC)',     specification: '98.5 – 101.5',             result: '99.7',                    unit: '%',  method: 'HPLC'   },
    { parameter: 'Identification',   specification: 'Conforms',                 result: 'Conforms',                unit: '',   method: 'IR'     },
    { parameter: 'Melting Point',    specification: '135 – 136 °C',             result: '135.4',                   unit: '°C', method: 'USP'    },
    { parameter: 'Loss on Drying',   specification: '≤ 0.5',                    result: '0.2',                     unit: '%',  method: 'USP'    },
    { parameter: 'Sulfated Ash',     specification: '≤ 0.1',                    result: '0.05',                    unit: '%',  method: 'USP'    },
    { parameter: 'Residual Solvents',specification: 'Complies',                 result: 'Complies',                unit: '',   method: 'GC'     },
  ],
  lab: {
    labName: 'Quality Control Lab',
    address: '123 Science Park, Innovation City, CA 94000, USA',
    testingMethod: 'USP / HPLC / ICH-M3',
    analyst: 'Sarah Johnson',
    approvedBy: 'David Miller',
    approvalDate: '2026-06-17',
  },
  includeQR: true,
};

export default function Sample() {
  const { t, lang } = useLang();

  const handleDownload = () => {
    generatePDF(sampleData, lang);
  };

  const sp = sampleData.specs;
  const p  = sampleData.product;
  const lb = sampleData.lab;

  return (
    <div style={s.page}>
      {/* Page header */}
      <div style={s.pageHeader}>
        <div>
          <p style={s.breadcrumb}>
            <Link to="/" style={s.breadLink}>Home</Link>
            {' / '}
            <span style={{ color: '#fff' }}>Sample Certificate</span>
          </p>
          <h1 style={s.pageTitle}>
            {lang === 'de' ? 'Musterzertifikat' : 'Sample Certificate'}
          </h1>
          <p style={s.pageSub}>
            {lang === 'de'
              ? 'Dies ist ein mit COA Lab generiertes Musterzertifikat.'
              : 'This is a sample Certificate of Analysis generated with COA Lab.'}
          </p>
        </div>
        <div style={s.headerActions}>
          <button style={s.dlBtn} onClick={handleDownload}>
            ⬇ {lang === 'de' ? 'PDF herunterladen' : 'Download PDF'}
          </button>
          <Link to="/register" style={s.ctaBtn}>
            {lang === 'de' ? 'Eigenes erstellen' : 'Create Your COA'}
          </Link>
        </div>
      </div>

      {/* Certificate card */}
      <div style={s.certCard}>

        {/* COA Header */}
        <div style={s.coaHeader}>
          <div style={s.coaLogo}>
            <span style={s.logoMain}>COA</span>
            <span style={s.logoAccent}>Lab</span>
          </div>
          <div style={s.coaTitleBlock}>
            <div style={s.coaTitle}>
              {lang === 'de' ? 'ANALYSENZERTIFIKAT' : 'CERTIFICATE OF ANALYSIS'}
            </div>
            <div style={s.coaId}>ID: {sampleData.certId}</div>
          </div>
          {/* QR placeholder */}
          <div style={s.qrBlock}>
            <svg width={72} height={72} viewBox="0 0 72 72" style={{ display: 'block' }}>
              {/* QR-like pattern */}
              {[
                [0,0,1,1,1,0,0,1,0,1,1,0,0,1,1,1,0,0],
                [0,1,0,0,0,1,0,1,0,1,0,1,0,1,0,0,1,0],
                [0,1,0,1,0,1,0,0,1,1,0,1,0,1,0,1,0,0],
                [0,1,0,1,0,1,0,1,0,0,1,0,0,1,0,1,0,0],
                [0,1,0,0,0,1,0,0,1,1,0,1,0,1,0,0,1,0],
                [0,0,1,1,1,0,0,1,0,0,1,0,0,0,1,1,1,0,0],
                [0,0,0,0,0,0,0,1,0,1,0,1,0,0,0,0,0,0],
                [1,1,0,1,0,1,1,0,1,0,1,1,1,0,1,1,0,1],
                [0,0,1,0,1,0,0,1,1,0,0,1,0,1,0,0,1,0],
                [1,0,1,1,0,1,0,0,0,1,0,0,1,1,0,1,0,1],
                [0,1,0,0,1,0,0,1,0,1,1,0,0,0,1,0,1,0],
                [1,0,1,0,0,1,1,0,1,0,0,1,1,0,0,1,0,1],
                [0,0,0,0,0,0,0,1,0,1,0,1,0,0,1,0,1,0],
                [0,0,1,1,1,0,0,0,1,0,1,0,1,1,0,1,1,0],
                [0,1,0,0,0,1,0,1,0,1,0,1,0,0,1,0,0,1],
                [0,1,0,1,0,1,0,0,1,1,0,0,1,0,1,1,0,0],
                [0,1,0,0,0,1,0,1,0,0,1,1,0,1,0,0,1,0],
                [0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,1,0,1],
              ].map((row, r) =>
                row.map((cell, c) => cell ? (
                  <rect key={`${r}-${c}`} x={c * 4} y={r * 4} width={3.5} height={3.5} fill="#0A1438" rx={0.4} />
                ) : null)
              )}
            </svg>
            <div style={s.qrLabel}>Scan to verify</div>
          </div>
        </div>

        <div style={s.divider} />

        {/* Product info grid */}
        <div style={s.section}>
          <h3 style={s.sectionTitle}>
            {lang === 'de' ? 'Produktinformationen' : 'Product Information'}
          </h3>
          <div style={s.infoGrid}>
            {[
              [lang === 'de' ? 'Produktname' : 'Product Name',          p.chemName],
              [lang === 'de' ? 'CAS-Nummer' : 'CAS Number',             p.casNumber],
              [lang === 'de' ? 'Molekülformel' : 'Molecular Formula',   p.formula],
              [lang === 'de' ? 'Molekulargewicht' : 'Molecular Weight', p.weight],
              [lang === 'de' ? 'Chargennummer' : 'Batch Number',        p.batch],
              [lang === 'de' ? 'Herstellungsdatum' : 'Mfg. Date',       p.mfgDate],
              [lang === 'de' ? 'Ablaufdatum' : 'Exp. Date',             p.expDate],
              [lang === 'de' ? 'Aussehen' : 'Appearance',               p.appearance],
              [lang === 'de' ? 'Lagerbedingungen' : 'Storage',          p.storage],
              [lang === 'de' ? 'Herkunftsland' : 'Country of Origin',   p.country],
            ].map(([label, value]) => (
              <div key={label} style={s.infoCell}>
                <div style={s.infoLabel}>{label}</div>
                <div style={s.infoValue}>{value}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={s.divider} />

        {/* Specs table */}
        <div style={s.section}>
          <h3 style={s.sectionTitle}>
            {lang === 'de' ? 'Spezifikationen & Ergebnisse' : 'Specifications & Results'}
          </h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={s.table}>
              <thead>
                <tr style={s.thead}>
                  {(lang === 'de'
                    ? ['Parameter', 'Spezifikation', 'Ergebnis', 'Einheit', 'Methode']
                    : ['Parameter', 'Specification', 'Result', 'Unit', 'Method']
                  ).map(h => <th key={h} style={s.th}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {sp.map((row, i) => (
                  <tr key={i} style={i % 2 === 0 ? s.trEven : s.trOdd}>
                    <td style={s.td}>{row.parameter}</td>
                    <td style={s.td}>{row.specification}</td>
                    <td style={{ ...s.td, fontWeight: 600, color: '#fff' }}>{row.result}</td>
                    <td style={s.td}>{row.unit || '—'}</td>
                    <td style={s.td}>{row.method}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={s.divider} />

        {/* Result + Lab */}
        <div style={s.bottomSection}>
          <div style={s.resultBlock}>
            <div style={s.passTag}>✓ {lang === 'de' ? 'BESTANDEN' : 'PASS'}</div>
            <p style={s.resultNote}>
              {lang === 'de'
                ? 'Dieses Produkt wurde geprüft und entspricht den aufgeführten Spezifikationen.'
                : 'This product has been tested and complies with the specifications listed above.'}
            </p>
            <p style={s.resultDate}>
              {lang === 'de' ? 'Datum:' : 'Date:'} {new Date().toLocaleDateString()}
            </p>
          </div>

          <div style={s.labBlock}>
            <h3 style={s.sectionTitle}>
              {lang === 'de' ? 'Laborinformationen' : 'Laboratory Information'}
            </h3>
            <div style={s.labGrid}>
              {[
                [lang === 'de' ? 'Labor' : 'Lab',             lb.labName],
                [lang === 'de' ? 'Adresse' : 'Address',       lb.address],
                [lang === 'de' ? 'Methode' : 'Method',        lb.testingMethod],
                [lang === 'de' ? 'Analytiker' : 'Analyst',    lb.analyst],
                [lang === 'de' ? 'Genehmigt von' : 'Approved by', lb.approvedBy],
                [lang === 'de' ? 'Datum' : 'Approval Date',   lb.approvalDate],
              ].map(([label, value]) => (
                <div key={label}>
                  <div style={s.infoLabel}>{label}</div>
                  <div style={s.infoValue}>{value}</div>
                </div>
              ))}
            </div>
            <div style={s.sigLine} />
            <div style={s.sigName}>{lb.approvedBy}</div>
            <div style={s.sigRole}>QC Manager</div>
          </div>
        </div>

        {/* Footer bar */}
        <div style={s.certFooter}>
          <span>COA Lab • coalab.app</span>
          <span>{sampleData.certId}</span>
          <span>{new Date().toLocaleDateString()}</span>
        </div>
      </div>

      {/* CTA block */}
      <div style={s.ctaBlock}>
        <div style={s.ctaInner}>
          <h2 style={s.ctaTitle}>
            {lang === 'de'
              ? 'Erstellen Sie jetzt Ihr eigenes Zertifikat'
              : 'Create your own Certificate of Analysis'}
          </h2>
          <p style={s.ctaSub}>
            {lang === 'de'
              ? 'Professionelles Format · Industriestandard · Einfach zu generieren'
              : 'Professional format · Industry standard · Ready to use'}
          </p>
          <div style={s.ctaActions}>
            <Link to="/register" style={s.ctaBtn}>
              {lang === 'de' ? 'Kostenlos loslegen' : 'Get Started Free'}
            </Link>
            <button style={s.dlBtn} onClick={handleDownload}>
              ⬇ {lang === 'de' ? 'Dieses PDF herunterladen' : 'Download this PDF'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#070F2B', padding: '84px 24px 48px', fontFamily: "'Inter', sans-serif", color: '#fff' },

  pageHeader: { maxWidth: 960, margin: '0 auto 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16 },
  breadcrumb: { fontSize: 13, color: 'rgba(255,255,255,0.4)', marginBottom: 8 },
  breadLink: { color: '#4A9EFF', textDecoration: 'none' },
  pageTitle: { fontSize: 30, fontWeight: 800, color: '#fff', margin: '0 0 6px' },
  pageSub: { fontSize: 14, color: 'rgba(255,255,255,0.55)' },
  headerActions: { display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' },

  certCard: { maxWidth: 960, margin: '0 auto 32px', background: '#fff', borderRadius: 20, overflow: 'hidden', color: '#1a1a2e', boxShadow: '0 24px 80px rgba(0,0,0,0.5)' },

  coaHeader: { background: '#0A1438', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 28px', gap: 16, flexWrap: 'wrap' },
  coaLogo: { display: 'flex', alignItems: 'baseline', gap: 3 },
  logoMain: { fontSize: 22, fontWeight: 900, color: '#fff' },
  logoAccent: { fontSize: 13, fontWeight: 700, color: '#4A9EFF' },
  coaTitleBlock: { textAlign: 'center', flex: 1 },
  coaTitle: { fontSize: 15, fontWeight: 800, color: '#fff', letterSpacing: 1.5 },
  coaId: { fontSize: 11, color: '#4A9EFF', fontFamily: 'monospace', marginTop: 4 },
  qrBlock: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, background: '#fff', borderRadius: 10, padding: 8 },
  qrLabel: { fontSize: 9, color: '#666', textAlign: 'center' },

  divider: { height: 1, background: '#e8eaf0', margin: '0 28px' },

  section: { padding: '20px 28px' },
  sectionTitle: { fontSize: 13, fontWeight: 800, color: '#0A1438', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 14 },

  infoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px 24px' },
  infoCell: {},
  infoLabel: { fontSize: 10, color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 3 },
  infoValue: { fontSize: 13, color: '#1a1a2e', fontWeight: 600 },

  table: { width: '100%', borderCollapse: 'collapse', minWidth: 540 },
  thead: { background: '#0A1438' },
  th: { padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#4A9EFF', letterSpacing: 0.4 },
  trEven: { background: '#f7f8fc' },
  trOdd: { background: '#fff' },
  td: { padding: '10px 14px', fontSize: 13, color: '#444', borderBottom: '1px solid #eef0f6' },

  bottomSection: { display: 'flex', gap: 0, flexWrap: 'wrap' },
  resultBlock: { flex: '0 0 auto', padding: '20px 28px', borderRight: '1px solid #e8eaf0', minWidth: 220 },
  passTag: { display: 'inline-block', background: '#dcfce7', color: '#16a34a', fontWeight: 800, fontSize: 15, padding: '8px 18px', borderRadius: 20, marginBottom: 12 },
  resultNote: { fontSize: 12, color: '#555', lineHeight: 1.6, maxWidth: 220, marginBottom: 8 },
  resultDate: { fontSize: 12, color: '#888' },

  labBlock: { flex: 1, padding: '20px 28px', minWidth: 260 },
  labGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 24px', marginBottom: 16 },
  sigLine: { width: 140, height: 1, background: '#333', marginBottom: 4 },
  sigName: { fontSize: 13, fontWeight: 700, color: '#1a1a2e' },
  sigRole: { fontSize: 11, color: '#888' },

  certFooter: { background: '#0A1438', display: 'flex', justifyContent: 'space-between', padding: '10px 28px', fontSize: 11, color: 'rgba(255,255,255,0.5)' },

  ctaBlock: { maxWidth: 960, margin: '0 auto' },
  ctaInner: { background: 'linear-gradient(135deg, rgba(30,94,255,0.12), rgba(74,158,255,0.06))', border: '1px solid rgba(30,94,255,0.25)', borderRadius: 20, padding: '36px 32px', textAlign: 'center' },
  ctaTitle: { fontSize: 24, fontWeight: 800, color: '#fff', marginBottom: 8 },
  ctaSub: { fontSize: 14, color: 'rgba(255,255,255,0.55)', marginBottom: 24 },
  ctaActions: { display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' },
  ctaBtn: { background: 'linear-gradient(135deg, #1E5EFF, #0A3DD4)', color: '#fff', textDecoration: 'none', padding: '13px 28px', borderRadius: 12, fontWeight: 700, fontSize: 15, border: 'none', cursor: 'pointer', display: 'inline-block' },
  dlBtn: { background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.18)', color: '#fff', padding: '13px 24px', borderRadius: 12, fontWeight: 600, fontSize: 15, cursor: 'pointer' },
};
